import { useSelector } from 'react-redux';

const usePermission = () => {
    const { isReadOnly, userInfo } = useSelector((state) => state.auth);
    
    return {
        canRead: true,
        canWrite: !isReadOnly,
        canEdit: !isReadOnly,
        canDelete: !isReadOnly,
        canCreate: !isReadOnly, 
        
        isReadOnly,
        userInfo,
        
        hasPermission: (action) => {
            const readActions = ['read', 'view', 'list'];
            const writeActions = ['create', 'update', 'edit', 'delete', 'write'];
            
            if (readActions.includes(action)) {
                return true;
            }
            
            if (writeActions.includes(action)) {
                return !isReadOnly;
            }
            
            return false;
        }
    };
};

export default usePermission; 